import React from 'react';
import styled from '@cthings.co/styled-components';
import { media } from '@cthings.co/styles-utils';
import { GraphRow } from '../../../common/styledComponents/StyledComponents';
import { EventsGraph } from './components/eventsGraph/EventsGraph';
import { EventsGraphFilters } from '../../../';

const StyledGraphRow = styled(GraphRow)`
  margin-top: 25px;
  gap: 40px;
  ${media.tablet} {
    margin-top: 45px;
  }
`;

export const History = ({ defaultFilters }: { defaultFilters: EventsGraphFilters }) => {
  return (
    <StyledGraphRow>
      <EventsGraph defaultFilters={defaultFilters} isSmartCapDevice />
    </StyledGraphRow>
  );
};
